import * as React from 'react';

export function LeftArrowIcon(): JSX.Element {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 7H3.83L9.415 1.415L8 0L0 8L8 16L9.415 14.585L3.83 9H16V7Z" fill="#236DFA" />
        </svg>
    );
}
